import {
  BookOpen,
  CreditCard,
  Heart,
  House,
  PiggyBank,
  Sparkle,
  Target,
  TrendUp,
  Users,
} from '@phosphor-icons/react';

const LUCIDE_BY_SLUG = {
  home: House,
  sparkles: Sparkle,
  'piggy-bank': PiggyBank,
  'book-open': BookOpen,
  target: Target,
  heart: Heart,
  users: Users,
  'trending-up': TrendUp,
  'credit-card': CreditCard,
};

/** Cores dos grupos do método — tokens `$group-*` / `$group-*-glow` do .pen. */
const GROUP_STYLE_BY_KEYWORD = [
  { keywords: ['necess', 'essencial', 'viver'], bg: 'bg-group-needs-glow', text: 'text-group-needs' },
  { keywords: ['desej', 'lazer', 'estilo', 'prazer'], bg: 'bg-group-wants-glow', text: 'text-group-wants' },
  { keywords: ['poupan', 'invest'], bg: 'bg-group-savings-glow', text: 'text-group-savings' },
  { keywords: ['dívida', 'divida', 'crédito', 'credito', 'emprést'], bg: 'bg-group-debt-glow', text: 'text-group-debt' },
];

export function resolveBudgetGroupIcon(slug) {
  if (!slug) return House;
  const normalized = String(slug).toLowerCase().replace(/_/g, '-');
  return LUCIDE_BY_SLUG[normalized] || House;
}

export function resolveBudgetGroupStyle(groupName = '') {
  const lower = groupName.toLowerCase();
  const match = GROUP_STYLE_BY_KEYWORD.find(({ keywords }) =>
    keywords.some((kw) => lower.includes(kw)),
  );
  return match || { bg: 'bg-group-needs-glow', text: 'text-group-needs' };
}
